export default __webpack_public_path__ + "static/media/04_Go-for-a-hikoi_Share.5216ced2.jpg";